module.exports = __webpack_public_path__ + "static/media/PatientSingleView.23e5d60a.png";